"use client";

import { useTranslations } from "next-intl";
import { useMemo } from "react";
import { Control } from "react-hook-form";

import FormSelect from "@/components/common/forms/FormSelect";
import FormTextField from "@/components/common/forms/FormTextField";
import { useBanks } from "@/contexts/BanksContext";
import { BankDetailsSchemaType } from "@/schemas/validation/bankValuationSchema";

interface BankValuationBankerDetailsStepProps {
  control: Control<BankDetailsSchemaType>;
}

const BankValuationBankerDetailsStep = ({ control }: BankValuationBankerDetailsStepProps) => {
  const { banks } = useBanks();
  const t = useTranslations("BankValuation.bankDetails");

  const bankOptions = useMemo(() => banks.map((b) => ({ value: b.name, label: b.name })), [banks]);

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <FormTextField
        name="bankerEmail"
        control={control}
        placeholder={t("bankerEmailPlaceholder")}
        required
        containerClassName=""
        inputMode="email"
      />

      <FormSelect
        name="bankName"
        control={control}
        placeholder={t("bankNamePlaceholder")}
        options={bankOptions}
        required
      />

      <FormTextField
        name="bankApplicationId"
        control={control}
        placeholder={t("bankApplicationIdPlaceholder")}
        required
        containerClassName="md:col-span-2"
      />
    </div>
  );
};

export default BankValuationBankerDetailsStep;
